export default __webpack_public_path__ + "static/Instagram-c41dd4003c989816f938aab78bdeeaad.svg";